// Auto-generated translation for fr.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:04:28.094564+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Pour les propriétaires de chevaux",
    title: "Tout pour votre cheval. Dans une seule application.",
    subtitle: "Gérez la santé, l'entraînement, la planification et les professionnels depuis un seul dossier clair.",
    primaryCTA: {
      label: "Commencer gratuitement",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Voir Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Profil du cheval — poids, vaccination, EquiCoach, alimentation et entraînement en un seul écran",
      caption: "Votre cheval, une vue complète.",
    },
    problem: "Vous gérez probablement vos rendez-vous, photos, entraînements, alimentation et données de santé de manière dispersée — dans des groupes WhatsApp, des boîtes à chaussures et des applications séparées. Résultat : vous perdez le fil.",
    solution: "EquiSight transforme votre cheval en un dossier numérique complet qui vous accompagne partout.",
    benefits: [
      "Un profil complet par cheval",
      "Santé, maréchal-ferrant, dentiste et kinésithérapeute au même endroit",
      "Agenda avec rappels intelligents",
      "Photos, notes et historique sans limite",
      "Sauvegarde de toutes vos données avec Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 cheval · toujours gratuit",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Plusieurs chevaux + sauvegarde",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Prêt à vous lancer ?",
      title: "Commencez dès aujourd'hui avec votre premier cheval.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Plus de chevaux. Plus de clarté. Plus de sérénité.",
    subtitle: "Passez à Premium et gérez tous vos chevaux sans limites — avec l'intelligence complète d'EquiCoach.",
    primaryCTA: {
      label: "Commencer 14 jours gratuits",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Tous les tarifs",
      href: "/#pricing",
    },
    audience: "Pour les propriétaires, cavaliers sportifs et détenteurs de plusieurs chevaux.",
    features: [
      "Ajouter un nombre illimité de chevaux",
      "Historique complet par cheval",
      "Sauvegarde des données",
      "Analyses EquiCoach approfondies",
      "Notifications intelligentes et planification",
      "Santé et entraînement entièrement connectés",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Moins de €0,17 par jour",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Prêt ?",
      title: "Passez à Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Pour les cavaliers de manège",
    title: "Progresser, même sans cheval à soi.",
    subtitle: "Suivez vos cours, entraînements et évolution dans EquiSight — pour moins qu'un café par mois pour papa ou maman. Ou une délicieuse glace avec de la chantilly.",
    primaryCTA: {
      label: "Démarrer avec Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Comment ça fonctionne ?",
      href: "#features",
    },
    problem: "En tant que cavalier de manège, vous n'avez souvent pas de cheval à vous, mais vous souhaitez tout de même progresser et garder une vue d'ensemble sur vos cours, vos objectifs et les chevaux sur lesquels vous montez.",
    solution: "Les fonctionnalités manège sont incluses de série dans Premium — suivez votre propre progression et consultez les chevaux de manège associés en lecture seule.",
    features: [
      "Suivre les entraînements",
      "Définir des objectifs",
      "Suivre la progression",
      "Consulter les chevaux de manège avec nom et photo",
      "Aucun accès aux données de santé privées",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Par mois · fonctionnalités manège incluses",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Rejoignez-nous",
      title: "Commencez en tant que cavalier de manège.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Pour les manèges & écuries",
    title: "Rendez votre manège numériquement accessible à chaque cavalier.",
    subtitle: "Offrez aux cavaliers un lien avec les chevaux, les cours et leur progression — sans partager de données sensibles sur l'écurie.",
    primaryCTA: {
      label: "Demander l'accès",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Voir les modules",
      href: "#features",
    },
    audience: "EquiSight aide les manèges et les écuries à fidéliser leurs cavaliers plus longtemps et à se démarquer numériquement.",
    features: [
      "Rendre les chevaux du manège visibles pour les cavaliers",
      "Nom et photo par cheval",
      "Associer les cavaliers aux chevaux",
      "Accès en lecture seule pour les données sensibles",
      "Historique des cours et entraînements centralisé",
      "Gestion des utilisateurs avec rôles",
    ],
    benefits: [
      "Plus de fidélité des cavaliers",
      "Image plus professionnelle",
      "Service numérique supplémentaire pour les membres",
      "Nouvelle source de revenus via l'utilisation de l'application",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Par mois · fonctionnalités manège incluses pour les cavaliers",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Prêt ?",
      title: "Activez le Module Manège.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Module Élevage",
    title: "Maîtrisez le cycle, la gestation et le développement du poulain.",
    subtitle: "Le module d'élevage complet pour les propriétaires de juments et les éleveurs — de la saillie au poulain, sur une seule chronologie.",
    primaryCTA: {
      label: "Activer le Module Élevage",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Voir les fonctionnalités",
      href: "#features",
    },
    audience: "Pour les éleveurs, les propriétaires de juments et les écuries gérant plusieurs juments.",
    features: [
      "Suivi du cycle",
      "Enregistrement des chaleurs",
      "Saisie des données d'insémination",
      "Compte à rebours jusqu'aux échographies",
      "Planification des contrôles de gestation",
      "Pedigree et ascendance",
      "Développement du poulain",
      "Vue d'ensemble de toutes les juments gestantes",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Par mois · Module Élevage inclus dans Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Commencez aujourd'hui",
      title: "Lancez-vous dans la gestion de l'élevage.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Module maréchal-ferrant",
    title: "Travaillez plus intelligemment en tant que maréchal-ferrant. Enregistrez tout de manière professionnelle.",
    subtitle: "Agenda, photos, remarques et historique des soins en un seul module — moins de malentendus, un dossier plus solide.",
    primaryCTA: {
      label: "Commencer en tant que maréchal-ferrant",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Voir le forfait Professional",
      href: "/professional",
    },
    audience: "Pour les maréchaux-ferrants qui souhaitent améliorer leur organisation, leur traçabilité et leur communication client.",
    features: [
      "Agenda personnel",
      "Rendez-vous par client",
      "Consulter les profils des chevaux",
      "Ajouter des photos avant et après",
      "Noter les soins effectués",
      "Enregistrer les conseils et remarques",
      "Notification ETA au client : \"Le maréchal-ferrant est en route\"",
    ],
    benefits: [
      "Travailler de manière plus professionnelle",
      "Moins de malentendus",
      "Meilleure constitution du dossier",
      "Position renforcée en cas de responsabilité",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Par mois · Module maréchal-ferrant inclus dans Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Prêt ?",
      title: "Activez le module maréchal-ferrant.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Module dentiste équin",
    title: "Un dossier dentaire complet par cheval.",
    subtitle: "Enregistrez les observations, les traitements et le suivi directement dans EquiSight.",
    primaryCTA: {
      label: "Commencer en tant que dentiste équin",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Voir le Pack Professional",
      href: "/professional",
    },
    audience: "Dentistes équins, vétérinaires et cabinets souhaitant travailler de manière structurée.",
    features: [
      "Enregistrer le contrôle dentaire",
      "Observations par traitement",
      "Ajouter des photos",
      "Rapport au propriétaire",
      "Conseils de suivi",
      "Historique par cheval",
      "Planifier un nouveau rendez-vous",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Par mois · Module dentiste équin inclus dans Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Prêt ?",
      title: "Activer le Module Dentiste Équin.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Module Physio / Ostéo",
    title: "Suivez le corps, le mouvement et la récupération de façon professionnelle.",
    subtitle: "Pour les physiothérapeutes et ostéopathes qui souhaitent accompagner les chevaux de manière structurée.",
    primaryCTA: {
      label: "Démarrer en tant que physio/ostéo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Voir le Pack Professional",
      href: "/professional",
    },
    features: [
      "Intake par cheval",
      "Enregistrer les observations corporelles",
      "Ajouter des photos et vidéos",
      "Créer un rapport de traitement",
      "Partager des exercices et le suivi",
      "Suivre le parcours de récupération",
      "Historique par cheval",
    ],
    benefits: [
      "Meilleure vision dans le temps",
      "Rapports professionnels",
      "Communication claire avec le propriétaire, l'entraîneur et le cavalier",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Par mois · Module Physio / Ostéo inclus dans Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Prêt(e) ?",
      title: "Activer le Module Physio / Ostéo.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Module Entraîneur",
    title: "Coachez vos cavaliers avec des données, des objectifs et des progrès.",
    subtitle: "Rendez l'entraînement mesurable et l'accompagnement plus professionnel — pour un ou plusieurs cavaliers.",
    primaryCTA: {
      label: "Démarrer en tant qu'entraîneur",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Voir le forfait Pro",
      href: "/#pricing",
    },
    audience: "Pour les instructeurs, entraîneurs et coaches accompagnant plusieurs cavaliers ou chevaux.",
    features: [
      "Associer des cavaliers",
      "Suivre les chevaux",
      "Définir des objectifs d'entraînement",
      "Donner des retours",
      "Analyser les résultats de compétition",
      "Consulter la progression par combinaison",
      "Utiliser des analyses de protocoles pour orienter l'entraînement",
    ],
    benefits: [
      "Un meilleur accompagnement",
      "Plus de structure",
      "Une communication plus professionnelle",
      "Un lien plus fort avec les clients",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Par mois · Module Entraîneur inclus dans Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Prêt(e) ?",
      title: "Activez le Module Entraîneur.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Analyse de compétition",
    title: "Du protocole à l'amélioration des performances.",
    subtitle: "Téléchargez votre protocole de compétition et découvrez où vous perdez des points — pas seulement consulter votre score, mais comprendre comment progresser.",
    primaryCTA: {
      label: "Analysez votre premier protocole",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Voir Premium",
      href: "/premium",
    },
    features: [
      "Télécharger une photo du protocole",
      "Traiter le recto et le verso",
      "Reconnaître la classe, le numéro d'épreuve et le juge",
      "Analyser les scores par élément",
      "Résumer les commentaires",
      "Afficher les points forts et les points faibles",
      "Tendances par combinaison cheval-cavalier",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Par mois · analyse de compétition incluse à partir de Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Prêt(e) ?",
      title: "Commencez avec l'analyse de compétition.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Forfait Professional",
    title: "Pour les professionnels du monde équestre.",
    subtitle: "Maréchal-ferrant, dentiste, kiné, ostéo ou entraîneur : collaborez dans un seul dossier numérique pour chaque cheval.",
    primaryCTA: {
      label: "Démarrer en tant que professionnel",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Voir les modules séparément",
      href: "#features",
    },
    audience: "Le Forfait Professional regroupe tous les modules métiers en un seul abonnement.",
    features: [
      "Module Maréchal-ferrant",
      "Module Dentiste",
      "Module Kiné / Ostéo",
      "Agenda & gestion des clients",
      "Profils des chevaux & rapports",
      "Historique des soins & constitution du dossier",
      "Communication avec le propriétaire",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Par mois · tous les modules métiers inclus",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Prêt ?",
      title: "Choisissez Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Numéros d'urgence cheval",
    title: "Toujours la bonne aide à portée de main.",
    subtitle: "En cas d'urgence, chaque seconde compte. Avec EquiSight, toutes les coordonnées importantes de votre cheval sont immédiatement disponibles — un seul appui et vous appelez.",
    primaryCTA: {
      label: "Préparez vos contacts d'urgence",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Commencez gratuitement avec EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Contacts d'urgence — appeler, envoyer un WhatsApp ou naviguer directement vers le vétérinaire, la clinique et le maréchal-ferrant",
      caption: "Un seul appui. Pas de panique.",
      embeddedFrame: true,
    },
    problem: "Votre cheval a un problème — colique, blessure, panique. Et c'est là que ça commence : qui appeler ? Avez-vous le bon numéro ? Est-ce le numéro d'urgence ? Un temps précieux est perdu.",
    solution: "Avec EquiSight, tout est immédiatement à portée de main. Pas de recherche. Pas de doute. Un seul appui et vous êtes en contact.",
    scenario: {
      title: "Imaginez — votre cheval présente des signes de colique.",
      steps: [
        "Vous ouvrez EquiSight",
        "Vous appuyez sur \"Vétérinaire\"",
        "Vous appelez directement",
      ],
      tagline: "Pas de stress. Pas de recherche. Seulement l'action.",
    },
    features: [
      "Tous les numéros d'urgence au même endroit",
      "Appel en un appui depuis l'application",
      "WhatsApp en un seul appui",
      "Navigation directe vers l'adresse",
      "Liste de contacts personnalisée par cheval",
      "Vétérinaire, clinique, maréchal-ferrant, dentiste, kinésithérapeute",
      "Adresse et itinéraire disponibles immédiatement",
      "Marquez vos numéros favoris avec une étoile",
      "Numéros d'urgence (112, 144) toujours en tête de liste",
    ],
    benefits: [
      "Calme et contrôle dans une situation d'urgence",
      "Tout le monde à l'écurie dispose des mêmes numéros",
      "Plus de cartes de visite oubliées",
      "Réagissez plusieurs secondes plus vite en cas d'urgence",
    ],
    audience: "Pour les propriétaires de chevaux, les soigneurs, les entraîneurs et les écuries — tous ceux qui sont responsables d'un cheval.",
    showcase: {
      eyebrow: "Configuré à l'avance pour vous",
      title: "13 catégories de contacts — prêtes à remplir.",
      description: "Du vétérinaire et de la clinique d'urgence au sellier, à l'instructeur et au gestionnaire de pâturage. EquiSight connaît votre univers et prépare les bons champs de contact pour vous. Appuyez, remplissez, c'est fait.",
      bullets: [
        "Urgence & santé — vétérinaire, urgences, clinique, ligne anti-poison",
        "Soins quotidiens — maréchal-ferrant, dentiste, kinésithérapeute, instructeur",
        "Écurie & pâturage — gérant d'écurie, gestionnaire de pâturage, pension",
        "Alimentation & matériel — fournisseurs de foin, aliments concentrés, paille",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Écran de gestion des contacts d'urgence — tous les contacts suggérés par catégorie",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Liste de contrôle des numéros d'urgence cheval",
      items: [
        "Vétérinaire",
        "Clinique d'urgence (24h/24 et 7j/7)",
        "Ambulance vétérinaire · 144",
        "Maréchal-ferrant",
        "Contact de secours",
        "Numéro d'alarme général · 112",
      ],
      cta: {
        label: "Ouvrir dans EquiSight et remplir directement",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Numéros d'urgence",
          price: "Gratis",
          note: "Toujours gratuit · pour tout le monde, dans chaque abonnement",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Assurez-vous d'être prêt",
      title: "Avant d'en avoir besoin.",
      href: "/#waitlist",
    },
    microcopy: [
      "Sans engagement",
      "Configuré en 2 minutes",
      "Toujours modifiable",
    ],
  },
};

export default LANDINGS;
